import { queryKeysBuilder } from '@/api/queries.utils';

const builder = queryKeysBuilder(['billetterie-orders']);

export const billetterieOrdersQueryKeys = {
  all: builder(),
  deferred: (params: object) => builder('deferred', params),
};
